import { Module, VuexModule, MutationAction, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';
import { StoreLocator, CmsBlock, Agreement, CartBanner } from '../models';
import { initState } from '../stateinit';
import { saveNewsletterAgreement } from '../api';
import to from 'await-to-js';
import errorHandler from '@/commons/errorHandler';

@Module({
    namespaced: true,
    name: 'cms',
    store,
    dynamic: true,
})
class CmsModule extends VuexModule {
    public blocks: CmsBlock[] = initState('cmsblocks');
    public cartBanners: CartBanner[] = initState('cartbanners');
    public agreements: Agreement[] = initState('agreements');

    get blockByName(): (name: string) => CmsBlock {
        return (name: string) => {
            const found = this.blocks.find(((block: CmsBlock) => block.name === name ));
            return (found as CmsBlock);
        };
    }

    get hasAgreements(): boolean {
        return this.agreements.length > 0;
    }

    get agreementByName(): (name: string) => Agreement {
        return (name: string) => {
            const found = this.agreements.find(((agreement: Agreement) => agreement.name === name ));
            return (found as Agreement);
        };
    }

    get approvedAgreementIds(): number[] {
        // const comboAgreements = store.state.options.combo_agreements
        //     && store.state.options.combo_agreements.saleconditions as string[];
        // const approvedNames = this.agreements.filter((a) => a.approved).map((a) => a.name);
        // for (const n of approvedNames) {
        //     if (comboAgreements.includes(n)) {
        //         for (const c of comboAgreements) {
        //             const ag = this.agreements.find(((agreement: Agreement) => agreement.name === c ));
        //             if (ag && !ag.approved) {
        //                 ag.approved = true;
        //             }
        //         }
        //     }
        // }
        return this.agreements.filter((a) => a.approved).map((a) => a.id);
    }

    get areRequiredAgreementsForPlaceOrderApproved(): boolean {
        const reqAgs = ['saleconditions'];
        return this.agreements.filter((a) => reqAgs.indexOf(a.name) !== -1).every((a) => a.approved);
    }

    @Mutation
    public removeAgreementByName(name: string) {
        const found = this.agreements.find(((agreement: Agreement) => agreement.name === name ));
        if (found) {
            this.agreements.splice(this.agreements.indexOf(found), 1);
        }
    }

    @Mutation
    public setAgreementFlag(payload: {agreement: Agreement, flag: boolean}) {
        const found = this.agreements.find(((ag: Agreement) => ag.name === payload.agreement.name ));
        if (found) {
            found.approved = payload.flag;
        }
    }

    @Mutation
    public setAgreements(agreements: Agreement[]) {
        this.agreements = agreements;
    }

    @Mutation
    public setBlocks(blocks: CmsBlock[]) {
        this.blocks = blocks;
    }

    @Mutation
    public setCartbanners(banners: CartBanner[]) {
        this.cartBanners = banners;
    }

    @Action
    public async registerNewsletterAgreement(email: string): Promise<string> {
        let err: any;
        let resp: any;
        if (this.agreementByName('privacyNewsLetter').approved) {
            [ err, resp ] = await to(saveNewsletterAgreement(email));
        }
        return new Promise((resolve, reject) => {
            if (err) {
                errorHandler(err);
                reject(err);
            } else {
                resolve(resp);
            }
        });
    }
}

export default getModule(CmsModule);

